export default "__VITE_ASSET__Bwuuh6tB__"